import React, { Component } from 'react'
import propTypes from 'prop-types'
import Icon from 'components/icon'
import {components} from 'react-select'

class Value extends Component {
  getColour = () => {
    const { data } = this.props
    if (data.colour) {
      return (
        <div
          className={'selectField-colour'}
          style={{backgroundColor: data.colour}}
        />
      )
    }
    return null
  }

  getIcon = () => {
    const { data } = this.props
    if (data.icon) return <Icon name={data.icon} color={data.iconColour} size={data.iconSize || 18} />
    return null
  }

  render() {
    const { children, ...otherProps } = this.props
    return (
      <components.SingleValue {...otherProps}>
        <div className="Select-value" title={otherProps.data.title}>
          <span className="Select-value-label">
            {this.getColour()}
            {this.getIcon()}
            {children}
          </span>
        </div>
      </components.SingleValue>
    )
  }
}

Value.propTypes = {
  children: propTypes.node,
  data: propTypes.shape({
    colour: propTypes.string,
    title: propTypes.string,
    icon: propTypes.string,
    iconSize: propTypes.number,
    iconColour: propTypes.string,
  }).isRequired,
}

export default Value
